import { useEffect, useState } from "react";


import CustomButton from "../../Components/CustomButton";
import CustomModal from "../../Components/CustomModal";
import ReviewProcessModal from "../../Components/ReviewProcessModal";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from '../../Components/Loader';
import CustomTable from "./../../Components/CustomTable";

import "./style.css";

import { faFilePdf, faImage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FormModal from "../../Components/FormModal";
import Header from "../../Components/Header";
import ProfileDisplay from "../../Components/ProfileDisplay";
import usePagination from "../../Hooks/usePagination";
import useSearch from "../../Hooks/useSearch";
import useToggle from "../../Hooks/useToggle";
import { useGetUsersQuery, useHandleStatusMutation } from "../../Redux/Apis/User";
import { useSendLoginLinkMutation } from "../../Redux/Apis/Admin";
import { toast } from "react-toastify";
import { dateFormatter, openFileInNewTab } from "../../Utils";

const sortValues = [
  {
    text: "Name",
    value: "fullName",
  },
  {
    text: "Email",
    value: "email",
  }
];

const perPageValues = [
  {
    text: "8",
    value: 8,
  },
  {
    text: "15",
    value: 15,
  },
  {
    text: "30",
    value: 30,
  }
];

export const UserRequests = () => {

  const [handleStatus, { isLoading: isUpdating }] = useHandleStatusMutation();
  const [sendLoginLink, { isLoading: isSendingLink }] = useSendLoginLinkMutation();

  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [showProcess, setShowProcess] = useState(false);
  const [reasonOpen, setReasonOpen] = useState(false)
  const [showSendLinkModal, setShowSendLinkModal] = useState(false);
  const [showSendLinkSuccessModal, setShowSendLinkSuccessModal] = useState(false);
  const [selectedUserForLink, setSelectedUserForLink] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(perPageValues[0].value);
  const [selectedUserId, setSelectedUserId] = useState();
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [sortBy, setSortBy] = useState(sortValues[0].value);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const [formOpen, setFormOpen, toggleForm] = useToggle()
  const [selectedData, setSelectedData] = useState()
  const [search, debouncedSearch, onSearch] = useSearch()
  const { page, perPage, onNext, onPrevious } = usePagination()
  const { data, isLoading, isFetching, refetch } = useGetUsersQuery({
    page,
    rowsPerPage: perPage,
    role: "vendor",
    status: "pending",
    search: debouncedSearch,
    sortBy,
    from,
    to,
  });

  const toggleFilter = () => setIsFilterOpen(!isFilterOpen)

  const inactiveMale = async () => {
    setShowModal3(false)
    setReasonOpen(true)
  }

  const activeMale = async () => {
    await handleStatus({ id: selectedUserId, payload: { status: "approved" } })
    refetch()
    setShowModal(false)
    setShowModal2(true)
  }

  const onConfirmReject = async (data) => {
    await handleStatus({ id: selectedUserId, payload: { status: "rejected", ...data } }).then(res => {
      if (!res?.error) {
        refetch()
        setReasonOpen(false)
        setShowModal4(true)
      }
    }).catch(err => {
      console.log("err", err)
    })
  }

  // Send a one-time magic login link to a vendor's email.
  const handleSendLoginLink = async () => {
    if (!selectedUserForLink) return;
    try {
      await sendLoginLink(selectedUserForLink._id).unwrap();
      setShowSendLinkModal(false);
      setShowSendLinkSuccessModal(true);
      setSelectedUserForLink(null);
    } catch (e) {
      toast.error(e?.data?.message || "Failed to send login code. Please try again.");
      setShowSendLinkModal(false);
    }
  };

  useEffect(() => {
    document.title = 'The Turn At | Vendor Approvals';
  }, []);

  const maleHeaders = [
    {
      key: "id",
      title: "S.No",
    },
    {
      key: "name",
      title: "Profile Name",
    },
    {
      key: "createdAt",
      title: "Profile Creation Date",
    },
    {
      key: "status",
      title: "Status",
    },
    {
      key: "actions",
      title: "",
    },
    {
      key: "loginCode",
      title: "Login",
    },
  ];

  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <Header
                  title="Vendor Approval Requests"
                  search={search}
                  onSearch={onSearch}
                  buttons={[
                    {
                      label: "View Review Process",
                      variant: "secondaryButton",
                      onClick: () => setShowProcess(true),
                    },
                  ]}
                />
                <div className="row mb-3">
                  {
                    (isLoading || isFetching) ? <Loader /> :
                      <div className="col-12">
                        <CustomTable
                          headers={maleHeaders}
                          isFilterOpen={isFilterOpen}
                          dateFilter={false}
                          filterSort={false}
                          perPage={true}
                          filterSortValues={sortValues}
                          perPageValues={perPageValues}
                          filterSortValue={sortBy}
                          setFilterSortValue={setSortBy}
                          filterFrom={from}
                          setFilterFrom={setFrom}
                          filterTo={to}
                          setFilterTo={setTo}
                          itemsPerPage={itemsPerPage}
                          setItemsPerPage={setItemsPerPage}
                          length={data?.data?.length}
                          page={page}
                          rowsPerPage={perPage}
                          onNext={onNext}
                          onPrevious={onPrevious}
                          total={data?.total}
                        >
                          <tbody>
                            {data?.data?.map((item, index) => (
                              <tr key={item._id}>
                                {/* <td><input type="checkbox" /></td> */}
                                <td>{(index + 1) + ((page - 1) * perPage)}</td>
                                <td>
                                  <ProfileDisplay
                                    name={`${item?.name}`}
                                    email={`${item?.email}`}
                                    image={item?.profile_photo}
                                  />
                                </td>
                                <td>{dateFormatter(item?.createdAt)}</td>
                                <td className="text-capitalize text-warning">{item.status}</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <p className="m-0 mx-2 cursor-pointer" onClick={() => {
                                    setSelectedData(item)
                                    toggleForm()
                                  }}>View Details</p>
                                  <CustomButton variant="successButton" text="Approve" className="mx-1" onClick={() => {
                                    setSelectedUserId(item._id)
                                    setShowModal(true)
                                  }} />
                                  <CustomButton variant="dangerButton" text="Decline" className="mx-1" onClick={() => {
                                    setSelectedUserId(item._id)
                                    setShowModal3(true)
                                  }} />
                                </td>
                                <td>
                                  {/* Send a magic login link to this vendor's email */}
                                  <CustomButton
                                    variant="secondaryButton"
                                    text="Send Login Code"
                                    className="btn-sm"
                                    onClick={() => {
                                      setSelectedUserForLink(item)
                                      setShowSendLinkModal(true)
                                    }}
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </CustomTable>
                      </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <FormModal
            title={`View Details`}
            open={formOpen}
            toggle={toggleForm}
            inputs={[
              { id: "name", label: "Name", placeholder: "Enter Name", initialValue: selectedData?.name, disabled: true },
              { id: "email", label: "Email", placeholder: "Enter Email", initialValue: selectedData?.email, disabled: true },
              { id: "years_of_experience", label: "Years of Experience", placeholder: "Enter Years of Experience", initialValue: selectedData?.details?.years_of_experience, disabled: true },
              { id: "phone_number", label: "Phone Number", placeholder: "Enter Phone", initialValue: selectedData?.details?.phone, disabled: true },
              { id: "about", label: "About", placeholder: "Enter About", initialValue: selectedData?.details?.about, disabled: true, type: "textarea" },
            ]}
          >
            <div className="row">
              <div className="col-xl-12 col-md-12 mb-3">
                <h4 className="mainLabel">Documents</h4>
                <div className="d-flex">
                  {
                    selectedData?.details?.documents?.length > 0 ?
                      selectedData?.details?.documents?.map(item => (
                        <div className="me-2 cursor-pointer" onClick={() => openFileInNewTab(item)}>
                          {
                            getFileType(item) == "pdf" ? <FontAwesomeIcon icon={faFilePdf} size="2xl" /> : isImage(item) ? <FontAwesomeIcon icon={faImage} size="2xl" /> : null
                          }
                        </div>
                      )) : <p>No Data Found</p>
                  }
                </div>
              </div>
            </div>
          </FormModal>

          <CustomModal loading={isUpdating} show={showModal} close={() => { setShowModal(false) }} action={activeMale} heading='Are you sure you want to approve this vendor?' />
          <CustomModal show={showModal2} close={() => { setShowModal2(false) }} success heading='Marked as Approved' />

          <CustomModal loading={isUpdating} show={showModal3} close={() => { setShowModal3(false) }} action={inactiveMale} heading='Are you sure you want to reject this vendor?' />
          <CustomModal show={showModal4} close={() => { setShowModal4(false) }} success heading='Marked as Rejected' />

          <ReviewProcessModal type="vendor" show={showProcess} onClose={() => setShowProcess(false)} />

          <FormModal
            title={`Reject Request`}
            open={reasonOpen}
            toggle={() => setReasonOpen(!reasonOpen)}
            onSubmit={onConfirmReject}
            inputs={[
              {
                id: "reason", label: "Reason", placeholder: "Enter Reason", required: true, initialValue: "", type: "textarea"
              }
            ]}
          />

          {/* Send Login Code — confirm before emailing a magic link to the vendor */}
          <CustomModal
            loading={isSendingLink}
            show={showSendLinkModal}
            close={() => {
              setShowSendLinkModal(false)
              setSelectedUserForLink(null)
            }}
            action={handleSendLoginLink}
            heading={`Send a one-time login code to ${selectedUserForLink?.name || 'this vendor'}? They'll receive it by email.`}
          />
          <CustomModal
            show={showSendLinkSuccessModal}
            close={() => setShowSendLinkSuccessModal(false)}
            success
            heading="Login code sent to their email."
          />

        </div>
      </DashboardLayout>
    </>
  );
};
